import React from 'react';
import MassEditModal from '../mass-edit-modal';
import { Form } from 'react-bootstrap';
import { useEditor } from '../mass-edit-modals';
import Selector from '../../facilitators/selector'

export default () => {
    const editor = useEditor({
        getInitialValue: ({ facilitatorId }) => ({ facilitatorId }),
    })

    return (
        <MassEditModal
            title={`Edit ${editor.experiences.length} Facilitators`}
            onCancel={editor.onClose}
            onSave={editor.save}
            disabled={!editor.value.facilitatorId}
            busy={editor.isBusy}
        >
            <Form.Group>
                <Form.Label>Location</Form.Label>
                <Selector value={editor.value.facilitatorId} onChange={(facilitatorId) => editor.setValue({ facilitatorId })} />
            </Form.Group>
        </MassEditModal>
    );
};
